import React from "react";
import Card from "./Card";
import Umumiy from "./Umumiy";
import Fan from "./Fan";
import Banner from "./Banner";
import HomeVideo from "./HomeVideo";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

function Home() {
  return (
    <div className="App">
      <Navbar />
      <Banner />
      <Card />
      <Umumiy />
      <Fan />
      <HomeVideo />
      <Footer />
    </div>
  );
}

export default Home;
